<template lang="pug">
  div.filters
    portal(to="cm-filters-chips")
      cm-filters-chips(
        :model="model"
        @remove="removeFilter"
      )
    cm-filters-list(
      :filters="filters" 
      @filterChanged="startFiltering"
    )
</template>

<script>
import {CMFiltersModel} from "../../core/models/cm-filters.model";

export default {
  data: () => ({
    model: {},
    filters: {
      search: '',
      examLocation: '',
      examDateBefore:  '',
      examDateAfter: ''
    }
  }),

  inject: ['getDefaultPagination'],
  
  created() {
    this.initFilters()
  },
  
  methods: {
    initFilters() {
      this.model = new CMFiltersModel(this.$route.query);
      this.setFilters();
    },
    
    async startFiltering() {
      this.setFiltersToModel();
      await this.setQuery();
    },

    setFiltersToModel() {
      for(let filter in this.filters) {
        if(filter in this.model.filters) {
          this.model.filters[filter] = this.filters[filter]
        }
      }
    },

    async setQuery(e) {
      await this.$router.replace({query: { ...this.$route.query, ...this.getDefaultPagination(), ...this.model.getApiData()}});
      this.$emit('filterChanged');
    },

    setFilters() {
      for(let filter in this.filters) {
        if(filter in this.model.filters) {
          this.filters[filter] = this.model.filters[filter]
        }
      }
    },

    removeFilter(field) {
      this.filters[field] = undefined;
      this.model.filters[field] = undefined;
      this.setQuery()
    },
  },
  components: {
    CmFiltersList: () => import('./CMFiltersList.vue'),
    CmFiltersChips: () => import('./CMFiltersChips.vue')
  }
}
</script>

<style lang="scss" scoped>
  
</style>
